import React, { useState } from 'react'
import { IBuffetGeneralReportResult } from 'core/api/dto/BuffetGeneralReportDto'
import { SubTableRepresentIntensity } from './SubTableRepresentIntensity'
import { useTranslation } from 'react-i18next'
import { headerDataFirstValue } from 'components/AppTable/components/headerDataFirstValue'
import { IHeaderData } from 'components/AppTable/AppTable'
import { AppTableDndMobile } from 'components/AppTable/AppTableDndMobile'

const headerDataIntensity = [
  {
    title: 'Наименование',
    colWidth: '20%',
    sort: 'name',
    order: 0,
    startPosition: 0,
  },
  { title: 'Станция', colWidth: '15%', order: 1, startPosition: 1 },
  { title: 'Дата', colWidth: '5%', order: 2, startPosition: 2 },
  { title: 'Тип замера', colWidth: '10%', order: 3, startPosition: 3 },
  {
    title: 'Значение типа замера',
    colWidth: '10%',
    order: 4,
    startPosition: 4,
  },
  {
    title: 'Кол-во замеров за интервал времени',
    colWidth: '10%',
    sort: 'dimensionsCount',
    order: 5,
    startPosition: 5,
  },
  {
    title: 'Итоговый вес за выбранный период времени, кг',
    colWidth: '13%',
    sort: 'actualWeight',
    order: 6,
    startPosition: 6,
  },
]

interface IReportFullProps {
  reportData: IBuffetGeneralReportResult[]
  next?: string | null
  onNextPage?: () => void
  isLoading?: boolean
  setCurrentSortValue: React.Dispatch<React.SetStateAction<string | null>>
}

export const ReportIntensity = ({
  reportData,
  setCurrentSortValue,
  next,
  onNextPage,
  isLoading,
}: IReportFullProps) => {
  const [toggleAllState, setToggleAllState] = useState<number[]>([])
  const { t } = useTranslation()
  const [headerDataDnd, setHeaderData] = useState<IHeaderData[]>(
    headerDataFirstValue('report-table-intensity', headerDataIntensity),
  )
  const subTableRepresentFn = (
    item: IBuffetGeneralReportResult,
    currentCol?: number,
    itemIndex?: number,
    onTouchStart?: ((e: React.TouchEvent) => void) | undefined,
    onTouchMove?: ((e: React.TouchEvent) => void) | undefined,
    width?: number,
    toggleAllState?: number[],
    headerData?: IHeaderData[],
  ) => (
    <SubTableRepresentIntensity
      item={item}
      currentCol={currentCol}
      itemIndex={itemIndex}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      width={width}
      toggleAllState={toggleAllState}
      toggleAllStateFullLenght={reportData.length}
      headerData={headerData}
    />
  )

  return (
    <React.Fragment>
      {reportData && (
        <AppTableDndMobile<
          IBuffetGeneralReportResult,
          keyof IBuffetGeneralReportResult
        >
          toggleAllState={toggleAllState}
          tableName="report-table-intensity"
          setHeaderData={setHeaderData}
          setToggleAllState={setToggleAllState}
          onNextPage={onNextPage}
          isLoading={isLoading}
          data={{
            count: 0,
            results: reportData,
            previous: '',
            next: next || '',
          }}
          tableWrapperClassName={'buffet-report-table'}
          tableCellClassName={'buffet-report-page-table-cell'}
          rowClassName={'buffet-report-page-table-category'}
          setCurrentSortFn={setCurrentSortValue}
          tableDataSelectors={[
            {
              renderItem: (item, index) => (
                <div
                  className={
                    index
                      ? 'violet-sticky'
                      : 'buffet-report-page-table-category-title'
                  }
                >
                  {t(item?.name)}
                </div>
              ),
            },
            {
              renderItem: (item) => <div></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>{item.dimensionsCount}</div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.actualWeight
                    ?.toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
          ]}
          subTableRepresent={subTableRepresentFn}
          headerData={headerDataDnd}
        />
      )}
    </React.Fragment>
  )
}
